import { Box } from '~/commonComponents';
import { ISelectOption } from '~/commonComponents/InputSelect';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

export const JobPostingStatusOptions: ISelectOption[] = [
  {
    title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Active),
    value: JobPostingStatus.Active,
    PrefixComponent: (
      <Box
        backgroundColor={JobPostingStatusMapper.getColor(JobPostingStatus.Active)}
        borderRadius="100%"
        height={10}
        width={10}
      />
    ),
  },
  {
    title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Closed),
    value: JobPostingStatus.Closed,
    PrefixComponent: (
      <Box
        backgroundColor={JobPostingStatusMapper.getColor(JobPostingStatus.Closed)}
        borderRadius="100%"
        height={10}
        width={10}
      />
    ),
  },
];
